import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Leak_detection() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>   איתור נזילות</h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Leak_detection"> איתור נזילות</Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
הנושא של איתור נזילות עבר מהפך של ממש בשנים האחרונות. אם בעבר, תקרה דולפת או עובש על הקיר גרם לנו לכאב ראש אמתי כי ידענו מה מצפה לנו בדרך לאיתור הנזילות, הרי שהיום, ניתן לאתר נזילות ללא הרמת מרצפות וללא חורים בקיר. ישנן פתרונות קסם שמסייעות לנו להגיע אל הנקודה המדויקת ללא כל נזק למבנה.
    </h2>
    <div className="content-row">


      <div className="image-box">
        <img src="/images/66.jpg" alt="roof" />
      </div>
      <div className="text-box">
        <p>כיום ישנם פתרונות רבים לכל מה שקשור לעולם האיטום. אם בעבר ידענו כי טפטוף מהתקרה או נזילה מהקיר זוהי יריית הפתיחה לבלגן רציני בבית וגם בכיס, היות ולצורך מציאת הנזילה היה צורך למצוא באופן פיזי את המקור, הרי שכיום, הסיפור הינו שונה לגמרי.
כיום ניתן בקלות לאתר תוך זמן קצר ממש את הנקודה הבעייתית באמצעים טכנולוגיים.</p>
      </div>

    </div>

    <h2 className="main-title">
איתור נזילות – איך זה נעשה עד היום?
    </h2>

    <div className="bottom-text">
      <p> עד לא מזמן ידענו כי כאשר ישנה נזילה מהגג, צריך לפתוח ולראות בדיוק איזה צינור הוא הבעייתי ומהיכן נגרמה הנזילה. ברור שדבר כזה כרוך בהרבה אבק, הרבה לכלוך, הרבה רעש והמון בלגן. לעיתים היה צורך בכלים מיוחדים וכבדים לצורך כך כאשר גם התיקון דרש התנהלות מערכתית מורכבת</p>

   <h2 className="main-title">
כך זה נעשה היום
    </h2>

      <p>אז איך למעשה מבצעים איתור נזילות? כיום עושים שימוש באמצעים מתקדמים כאשר בראשם יש לנו את המצלמה הטרמית. המצלמה היא זו שמאפשרת את הגילוי המדויק של המוקד הבעייתי כאשר די בהצצה קלה של המצלמה אל תוך הצנרת ונקודת התורפה מתגלה באופן מדויק. אנו מתמחים באיתור נזילות ומבצעים איטום ותיקון.
כאשר הנזילה היא בגג, שם יש צורך בציוד מתאים בכדי שניתן יהיה לשלוט הן באבחון של הנזילה והן בטיפול הנכון והמקצועי ביותר. </p>

  <h2 className="main-title">
כל קבלן איטום יודע לעשות את זה?
    </h2>


      <p>  אז האם כיום יידע כל קבלן איטום איך וכיצד לבצע את העבודה הזו? האם כולם מצוידים בכלים החדשניים והם בקיאים בכל הפיתוחים אשר מאפשרים לאתר נזילות ואף לפתור אותם בקלות ובמהירות?
אז האמת היא שכמו בכל דבר, גם כאן ישנם אנשי המקצוע המעודכנים הפועלים עם הכלים החדשניים ויש את אלו שעדיין נאמנים לפטיש ולאזמל.
על כן לפני שאתם מצלצלים אל בעל המקצוע המוכר והוותיק שלכם, או לעו"ד ליקויי בניה על מנת לתבוע את הקבלן על ליקויים בדירה, כדאי שתבדקו האם הוא מכיר את החידושים האחרונים בתחום האיטום. אם הוא עדיין דבק בשיטות העתיקות, אולי הגיע הזמן שתפנו אל אנשי מקצוע אחרים.
אצלנו תוכלו למצוא את כל השירותים הקשורים לאיטום גגות, זיפות גגות, החלפה של כל סוגי הגגות, איתור נזילות ופתרונות לכל הבעיות מן הסוג הזה. </p>

    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Rain_is_good_but_not_in_doors" className="link-right" >גשם זה טוב - לא בתוך הבית</Link>
  <Link to="/How_to_choose_a_professional_for_roof_waterproofing" className="link-left" >  כיצד לבחור בעל מקצוע לאיטום גגות</Link>

</div>

      </div>
    </div>
  

      </div>
  );
}


